/* 展开和收起 */
<template>
  <div class="zToggleFold">
    <Row type="flex" justify="center" align="middle">
      <Col span="20" class="left">{{ title }}</Col>
      <Col span="4" class="right" @click.native="toggleHandle"
        >{{ btx }}
        <i v-if="toggle" class="iconfont icon-arrowupper"></i>
        <i v-else class="iconfont icon-arrowlower"></i>
      </Col>
    </Row>
    <div :class="toggle ? '' : 'solt-height'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZToggleFold",
  data() {
    return {
      toggle: false
    };
  },
  props: {
    defaultCon: {
      type: Boolean,
      default: false
    },
    title: {
      type: [String, Number],
      default: ""
    },
    btx: {
      type: [String, Number],
      default: "展开"
    }
  },
  watch: {
    defaultCon: function() {
      this.toggle = this.defaultCon;
    }
  },
  methods: {
    toggleHandle() {
      this.toggle = !this.toggle;
    }
  },
  created() {
    this.toggle = this.defaultCon;
  }
};
</script>

<style lang="scss" scoped>
.zToggleFold {
  .left {
    text-align: left;
    font-weight: 500;
    font-size: 16px;
  }
  .right {
    text-align: right;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    i {
      font-size: 12px;
      color: #999999;
      display: inline-block;
      margin-left: 2px;
      vertical-align: middle;
    }
  }
  .solt-height {
    height: 0px;
    overflow: hidden;
    transition: all 2s;
  }
}
</style>
